'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var dagPB = require('@ipld/dag-pb');

var Errors = require('datastore-core/errors');

var toCidAndPath = require('ipfs-core-utils/to-cid-and-path');

var cid = require('multiformats/cid');

var TimeoutController = require('timeout-abort-controller');

var anySignal = require('any-signal');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var TimeoutController__default = /*#__PURE__*/_interopDefaultLegacy(TimeoutController);

var ERR_NOT_FOUND = Errors.notFoundError().code;
var Format = {
  default: '<dst>',
  edges: '<src> -> <dst>'
};

function createRefs(_ref) {
  var repo = _ref.repo,
      codecs = _ref.codecs,
      resolve = _ref.resolve,
      preload = _ref.preload;

  function refs(_x) {
    return _refs.apply(this, arguments);
  }

  function _refs() {
    _refs = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ipfsPath) {
      var options,
          controller,
          rawPaths,
          paths,
          _iterator3,
          _step3,
          path,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

              if (!(options.maxDepth === 0)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              if (!(options.edges && options.format && options.format !== Format.default)) {
                _context.next = 5;
                break;
              }

              throw new Error('Cannot set edges to true and also specify format');

            case 5:
              options.format = options.edges ? Format.edges : options.format;

              if (typeof options.maxDepth !== 'number') {
                options.maxDepth = options.recursive ? Infinity : 1;
              }

              if (options.timeout) {
                controller = new TimeoutController__default["default"](options.timeout);
                options.signal = anySignal.anySignal([options.signal, controller.signal]);
              }

              rawPaths = Array.isArray(ipfsPath) ? ipfsPath : [ipfsPath];
              paths = rawPaths.map(function (p) {
                return getFullPath(preload, p, options);
              });
              _iterator3 = _createForOfIteratorHelper(paths);
              _context.prev = 11;

              _iterator3.s();

            case 13:
              if ((_step3 = _iterator3.n()).done) {
                _context.next = 25;
                break;
              }

              path = _step3.value;
              _context.prev = 15;
              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(refsStream(resolve, repo, codecs, path, options)), _awaitAsyncGenerator), "t0", 17);

            case 17:
              _context.next = 23;
              break;

            case 19:
              _context.prev = 19;
              _context.t1 = _context["catch"](15);
              _context.next = 23;
              return {
                ref: '',
                err: _context.t1.message
              };

            case 23:
              _context.next = 13;
              break;

            case 25:
              _context.next = 30;
              break;

            case 27:
              _context.prev = 27;
              _context.t2 = _context["catch"](11);

              _iterator3.e(_context.t2);

            case 30:
              _context.prev = 30;

              _iterator3.f();

              return _context.finish(30);

            case 33:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[11, 27, 30, 33], [15, 19]]);
    }));
    return _refs.apply(this, arguments);
  }

  return refs;
}

function getFullPath(preload, ipfsPath, options) {
  var _toCidAndPath$toCidAn = toCidAndPath.toCidAndPath(ipfsPath),
      cid = _toCidAndPath$toCidAn.cid,
      path = _toCidAndPath$toCidAn.path;

  if (options.preload !== false) {
    preload(cid);
  }

  return "/ipfs/".concat(cid).concat(path || '');
}

function refsStream(_x2, _x3, _x4, _x5, _x6) {
  return _refsStream.apply(this, arguments);
}

function _refsStream() {
  _refsStream = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, repo, codecs, path, options) {
    var resPath, _toCidAndPath$toCidAn2, cid, maxDepth, unique, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, obj;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _awaitAsyncGenerator(resolve(path, options));

          case 2:
            resPath = _context2.sent;
            _toCidAndPath$toCidAn2 = toCidAndPath.toCidAndPath(resPath), cid = _toCidAndPath$toCidAn2.cid;
            maxDepth = options.maxDepth != null ? options.maxDepth : Infinity;
            unique = options.unique || false;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 8;
            _iterator = _asyncIterator(objectStream(repo, codecs, cid, maxDepth, unique, options));

          case 10:
            _context2.next = 12;
            return _awaitAsyncGenerator(_iterator.next());

          case 12:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 23;
              break;
            }

            obj = _step.value;

            if (obj.parent) {
              _context2.next = 16;
              break;
            }

            return _context2.abrupt("continue", 20);

          case 16:
            if (!obj.isDuplicate) {
              _context2.next = 18;
              break;
            }

            return _context2.abrupt("continue", 20);

          case 18:
            _context2.next = 20;
            return {
              ref: formatLink(obj.parent.cid, obj.node.cid, obj.node.name, options.format)
            };

          case 20:
            _iteratorAbruptCompletion = false;
            _context2.next = 10;
            break;

          case 23:
            _context2.next = 29;
            break;

          case 25:
            _context2.prev = 25;
            _context2.t0 = _context2["catch"](8);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 29:
            _context2.prev = 29;
            _context2.prev = 30;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 34;
              break;
            }

            _context2.next = 34;
            return _awaitAsyncGenerator(_iterator.return());

          case 34:
            _context2.prev = 34;

            if (!_didIteratorError) {
              _context2.next = 37;
              break;
            }

            throw _iteratorError;

          case 37:
            return _context2.finish(34);

          case 38:
            return _context2.finish(29);

          case 39:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8, 25, 29, 39], [30,, 34, 38]]);
  }));
  return _refsStream.apply(this, arguments);
}

function formatLink(srcCid, dstCid) {
  var linkName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Format.default;
  var out = format.replace(/<src>/g, srcCid.toString());
  out = out.replace(/<dst>/g, dstCid.toString());
  out = out.replace(/<linkname>/g, linkName);
  return out;
}

function objectStream(_x7, _x8, _x9, _x10, _x11, _x12) {
  return _objectStream.apply(this, arguments);
}

function _objectStream() {
  _objectStream = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(repo, codecs, rootCid, maxDepth, uniqueOnly, options) {
    var seen, traverseLevel, _traverseLevel;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _traverseLevel = function _traverseLevel3() {
              _traverseLevel = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(parent, depth) {
                var nextLevelDepth, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, link;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        nextLevelDepth = depth + 1;

                        if (!(nextLevelDepth > maxDepth)) {
                          _context3.next = 3;
                          break;
                        }

                        return _context3.abrupt("return");

                      case 3:
                        _context3.prev = 3;
                        _iteratorAbruptCompletion2 = false;
                        _didIteratorError2 = false;
                        _context3.prev = 6;
                        _iterator2 = _asyncIterator(getLinks(repo, codecs, parent.cid, options));

                      case 8:
                        _context3.next = 10;
                        return _awaitAsyncGenerator(_iterator2.next());

                      case 10:
                        if (!(_iteratorAbruptCompletion2 = !(_step2 = _context3.sent).done)) {
                          _context3.next = 19;
                          break;
                        }

                        link = _step2.value;
                        _context3.next = 14;
                        return {
                          parent: parent,
                          node: link,
                          isDuplicate: uniqueOnly && seen.has(link.cid.toString())
                        };

                      case 14:
                        if (uniqueOnly) {
                          seen.add(link.cid.toString());
                        }

                        return _context3.delegateYield(_asyncGeneratorDelegate(_asyncIterator(traverseLevel(link, nextLevelDepth)), _awaitAsyncGenerator), "t0", 16);

                      case 16:
                        _iteratorAbruptCompletion2 = false;
                        _context3.next = 8;
                        break;

                      case 19:
                        _context3.next = 25;
                        break;

                      case 21:
                        _context3.prev = 21;
                        _context3.t1 = _context3["catch"](6);
                        _didIteratorError2 = true;
                        _iteratorError2 = _context3.t1;

                      case 25:
                        _context3.prev = 25;
                        _context3.prev = 26;

                        if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                          _context3.next = 30;
                          break;
                        }

                        _context3.next = 30;
                        return _awaitAsyncGenerator(_iterator2.return());

                      case 30:
                        _context3.prev = 30;

                        if (!_didIteratorError2) {
                          _context3.next = 33;
                          break;
                        }

                        throw _iteratorError2;

                      case 33:
                        return _context3.finish(30);

                      case 34:
                        return _context3.finish(25);

                      case 35:
                        _context3.next = 41;
                        break;

                      case 37:
                        _context3.prev = 37;
                        _context3.t2 = _context3["catch"](3);

                        if (_context3.t2.code === ERR_NOT_FOUND) {
                          _context3.t2.message = "Could not find object with CID: ".concat(parent.cid);
                        }

                        throw _context3.t2;

                      case 41:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[3, 37], [6, 21, 25, 35], [26,, 30, 34]]);
              }));
              return _traverseLevel.apply(this, arguments);
            };

            traverseLevel = function _traverseLevel2(_x17, _x18) {
              return _traverseLevel.apply(this, arguments);
            };

            seen = new Set();
            return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(traverseLevel({
              cid: rootCid
            }, 0)), _awaitAsyncGenerator), "t0", 4);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _objectStream.apply(this, arguments);
}

function getLinks(_x13, _x14, _x15, _x16) {
  return _getLinks.apply(this, arguments);
}

function _getLinks() {
  _getLinks = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(repo, codecs, cid, options) {
    var block, codec, value, isDagPb, base, _iterator4, _step4, _step4$value, name, _cid, match, index;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _awaitAsyncGenerator(repo.blocks.get(cid, options));

          case 2:
            block = _context5.sent;
            _context5.next = 5;
            return _awaitAsyncGenerator(codecs.getCodec(cid.code));

          case 5:
            codec = _context5.sent;
            value = codec.decode(block);
            isDagPb = cid.code === dagPB__namespace.code;
            base = [];
            _iterator4 = _createForOfIteratorHelper(links(value, base));
            _context5.prev = 10;

            _iterator4.s();

          case 12:
            if ((_step4 = _iterator4.n()).done) {
              _context5.next = 26;
              break;
            }

            _step4$value = _slicedToArray(_step4.value, 2), name = _step4$value[0], _cid = _step4$value[1];

            if (!isDagPb) {
              _context5.next = 22;
              break;
            }

            match = name.match(/^Links\/(\d+)\/Hash$/);

            if (!match) {
              _context5.next = 22;
              break;
            }

            index = Number(match[1]);

            if (!(index < value.Links.length)) {
              _context5.next = 22;
              break;
            }

            _context5.next = 21;
            return {
              name: value.Links[index].Name,
              cid: _cid
            };

          case 21:
            return _context5.abrupt("continue", 24);

          case 22:
            _context5.next = 24;
            return {
              name: name,
              cid: _cid
            };

          case 24:
            _context5.next = 12;
            break;

          case 26:
            _context5.next = 31;
            break;

          case 28:
            _context5.prev = 28;
            _context5.t0 = _context5["catch"](10);

            _iterator4.e(_context5.t0);

          case 31:
            _context5.prev = 31;

            _iterator4.f();

            return _context5.finish(31);

          case 34:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[10, 28, 31, 34]]);
  }));
  return _getLinks.apply(this, arguments);
}

var links = /*#__PURE__*/_regeneratorRuntime.mark(function links(source, base) {
  var _i, _Object$entries, _Object$entries$_i, key, value, path, _iterator5, _step5, _step5$value, index, element, elementPath, cid$1, _cid$;

  return _regeneratorRuntime.wrap(function links$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!(source == null)) {
            _context6.next = 2;
            break;
          }

          return _context6.abrupt("return");

        case 2:
          if (!(source instanceof Uint8Array)) {
            _context6.next = 4;
            break;
          }

          return _context6.abrupt("return");

        case 4:
          _i = 0, _Object$entries = Object.entries(source);

        case 5:
          if (!(_i < _Object$entries.length)) {
            _context6.next = 46;
            break;
          }

          _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
          path = [].concat(_toConsumableArray(base), [key]);

          if (!(value != null && typeof value === 'object')) {
            _context6.next = 43;
            break;
          }

          if (!Array.isArray(value)) {
            _context6.next = 36;
            break;
          }

          _iterator5 = _createForOfIteratorHelper(value.entries());
          _context6.prev = 11;

          _iterator5.s();

        case 13:
          if ((_step5 = _iterator5.n()).done) {
            _context6.next = 26;
            break;
          }

          _step5$value = _slicedToArray(_step5.value, 2), index = _step5$value[0], element = _step5$value[1];
          elementPath = [].concat(_toConsumableArray(path), [index]);
          cid$1 = cid.CID.asCID(element);

          if (!cid$1) {
            _context6.next = 22;
            break;
          }

          _context6.next = 20;
          return [elementPath.join('/'), cid$1];

        case 20:
          _context6.next = 24;
          break;

        case 22:
          if (!(typeof element === 'object')) {
            _context6.next = 24;
            break;
          }

          return _context6.delegateYield(links(element, elementPath), "t0", 24);

        case 24:
          _context6.next = 13;
          break;

        case 26:
          _context6.next = 31;
          break;

        case 28:
          _context6.prev = 28;
          _context6.t1 = _context6["catch"](11);

          _iterator5.e(_context6.t1);

        case 31:
          _context6.prev = 31;

          _iterator5.f();

          return _context6.finish(31);

        case 34:
          _context6.next = 43;
          break;

        case 36:
          _cid$ = cid.CID.asCID(value);

          if (!_cid$) {
            _context6.next = 42;
            break;
          }

          _context6.next = 40;
          return [path.join('/'), _cid$];

        case 40:
          _context6.next = 43;
          break;

        case 42:
          return _context6.delegateYield(links(value, path), "t2", 43);

        case 43:
          _i++;
          _context6.next = 5;
          break;

        case 46:
          return _context6.abrupt("return", []);

        case 47:
        case "end":
          return _context6.stop();
      }
    }
  }, links, null, [[11, 28, 31, 34]]);
});

exports.Format = Format;
exports.createRefs = createRefs;